import React from 'react';
import Logo from '../../images/SKIP.svg';
import type { OnboardingStep } from './types';

type OnboardingNavProps = {
  step: OnboardingStep;
  furthestStep?: OnboardingStep;
  onStepSelect?: (step: OnboardingStep) => void;
  onLogout: () => void;
};

const STEPS: Array<{ id: OnboardingStep; label: string; number: number }> = [
  { id: 'welcome', label: 'Welcome', number: 1 },
  { id: 'resume', label: 'Resume', number: 2 },
  { id: 'linkedin', label: 'LinkedIn', number: 3 },
  { id: 'review', label: 'Review', number: 4 },
];

const stepOrder: Record<OnboardingStep, number> = {
  welcome: 0,
  resume: 1,
  linkedin: 2,
  review: 3,
};

export default function OnboardingNav({
  step,
  furthestStep = 'welcome',
  onStepSelect,
  onLogout,
}: OnboardingNavProps) {
  const activeIndex = stepOrder[step];
  const furthestIndex = stepOrder[furthestStep];

  return (
    <div className="ssr-nav">
      <img src={Logo} alt="SkipScreen" className="ssr-logo-img" width={120} height={60} />

      <div className="ssr-steps">
        {STEPS.map((item, index) => {
          const isReachable = stepOrder[item.id] <= furthestIndex;
          const isActive = step === item.id;
          const isDone = activeIndex > index;

          return (
            <React.Fragment key={item.id}>
              {index > 0 ? <div className="ssr-step-line" aria-hidden /> : null}
              {isReachable && onStepSelect ? (
                <button
                  type="button"
                  className={`ssr-step ssr-step--button ${
                    isActive ? 'active' : isDone ? 'done' : ''
                  }`}
                  onClick={() => onStepSelect(item.id)}
                  aria-current={isActive ? 'step' : undefined}
                >
                  <div className="ssr-step-circle">{isDone && !isActive ? '✓' : item.number}</div>
                  <span>{item.label}</span>
                </button>
              ) : (
                <div
                  className={`ssr-step ${isActive ? 'active' : isDone ? 'done' : ''}`}
                  aria-current={isActive ? 'step' : undefined}
                >
                  <div className="ssr-step-circle">{isDone && !isActive ? '✓' : item.number}</div>
                  <span>{item.label}</span>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <button type="button" className="ssr-logout-btn" onClick={onLogout}>
        Log out
      </button>
    </div>
  );
}
